import { PERMISSIONS } from "@/utils/constants";
import permissionMiddleware from "@/router/middlewares/permissionMiddleware";
import authMiddleware from "@/router/middlewares/authMiddleware";

export default [
  {
    path: "/realization",
    name: "realization-index",
    component: () => import("../pages/admin/realization/index"),
    meta: {
      middleware: [
        authMiddleware,
        permissionMiddleware(PERMISSIONS.REALIZATION),
      ],
    },
  },
  {
    path: "/ozl-outgoing-contracts",
    name: "ozl-outgoing-contracts",
    component: () => import("../pages/admin/realization/outgoing-contract"),
    meta: {
      middleware: [
        authMiddleware,
        permissionMiddleware(PERMISSIONS.REALIZATION),
      ],
    },
  },
];
